import Toasty from 'components/atoms/Toasty';
import { useSelector } from 'react-redux';
import { GetCustomerSettlementAccount } from 'Services';
import { IAPI_ACTION, IDispatcherType, INITIAL_STATE } from 'types';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

export const setAPIError = (state: ReturnType<typeof INITIAL_STATE>, action: IAPI_ACTION): void => {
	state.loading = false;
	state.error = action.error.message || 'Something went wrong';
	Toasty.error(state.error);
};

export const customerSettlementAccount = createAsyncThunk(
	'get/customerSettlementAccount',
	GetCustomerSettlementAccount,
);
export const CustomerSettlementAccountSlice = createSlice({
	name: 'customerSettlementAccount',
	initialState: INITIAL_STATE(),

	reducers: {
		CLEAR_ERROR: (state) => {
			state.error = '';
		},
		RESET: (state) => Object.assign(state, INITIAL_STATE()),
		SET_CUSTOMER_SETTLEMENT_ACCOUNT_DATA: (state, payload) => {
			state.data = payload.payload;
		},
	},
	extraReducers: {
		[customerSettlementAccount.pending.toString()]: (state: ReturnType<typeof INITIAL_STATE>) => {
			state.data = {};
			state.loading = true;
		},
		[customerSettlementAccount.rejected.toString()]: setAPIError,
		[customerSettlementAccount.fulfilled.toString()]: (state, action: IAPI_ACTION<any>) => {
			state.loading = false;
			state.data = action.payload;
		},
	},
});
export const { SET_CUSTOMER_SETTLEMENT_ACCOUNT_DATA } = CustomerSettlementAccountSlice.actions;

export interface IStates {
	[CustomerSettlementAccountSlice.name]: ReturnType<typeof CustomerSettlementAccountSlice.reducer>;
}

export const CustomerSettlementAccountSelector = (state: IStates): any => {
	return state[CustomerSettlementAccountSlice.name] || {};
};

export const useCustomerSettlementAccount = (): any => useSelector(CustomerSettlementAccountSelector);

export const triggerCustomerSettlementAccountApi =
	() =>
	async (dispatch: IDispatcherType): Promise<void> => {
		await dispatch(customerSettlementAccount());
		return;
	};
